<div class="toolbar">
    <div class="table-sio w-100">
        <div class="cell-sio text-middle text-md-left w-lg-235x">

            <img *ngIf="(!isPremier && !isUpSivale && !isCenegas)" class="logo"
                src="./assets/images/logo.svg"
                (click)="inicio()">


                <img *ngIf="isPremier" class="logo"
                src="../../../assets/images/premier/premier.png"
                (click)="inicio()">

                <img *ngIf="isUpSivale" class="logo"
                src="../../../assets/images/upsivale/upsivale.png"
                (click)="inicio()">

                <img *ngIf="isCenegas" class="logo"
                src="../../../assets/images/cenegas/cenagas.png"
                (click)="inicio()">



        </div>

        <div class="container-help table-sio float-right mt-4" *ngIf="isMobile" (click)="openModalMarcame()">

            <div class="cell-sio text-middle text-center">
                <mat-icon class="letter-color-help text-middle" style="color: #FFFFFF !important;">phone</mat-icon>
            </div>                                
            <div  class="letter-color-help cell-sio text-middle text-center" style="color: #FFFFFF !important;">contáctanos</div>
        </div>

        <ng-container *ngIf="datoOculto">
            <div class="cell-sio text-middle display-mobil-tablet-none text-center w-100">
                <div class="table-sio banner-fx">
                    <div class="cell-sio text-middle text-left">
                        <a *ngIf="!isUpSivale" class="link headerText"  (click)="openWindow(7)">Seguros</a>
                    </div>
                    <div class="cell-sio text-middle text-left">
                        <a *ngIf="!isUpSivale" class="link headerText" id="btn_quienes_somos" (click)="openWindow(4)">¿Quienes somos?</a>
                    </div>
                    <div class="cell-sio text-middle text-center">
                      <a class="link headerText" (click)="openWindow(3)">Blog</a>
                    </div>
                    <div class="cell-sio text-middle text-center">
                      <a class="link headerText" (click)="openWindow(2)">Promociones</a>
                    </div>
                    <div class="cell-sio text-middle text-right">
                        <ng-container *ngIf="isProfile; else elseProfile">
                            <span>
                                <div class="table-sio underline float-right">
                                    <div class="cell-sio text-middle text-right">
                                        <span [matMenuTriggerFor]="menu">
                                            <h4 class="profile-t text-right">{{profile.nombre}}</h4>
                                            <p class="profile-s text-right">{{profile.correo}}</p>
                                        </span>
                                    </div>
                                    <div class="cell-sio text-middle px-10x">
                                        <button id="btn-menu2" mat-icon-button class="btn-icon foto"
                                            [matMenuTriggerFor]="menu">
                                            <div id="text-middle">
                                                <mat-icon class="color-icon icono-40 text-top">
                                                    <img class="profile-img" [src]="profile.photo">
                                                </mat-icon>
                                            </div>
                                        </button>
                                        <mat-menu #menu="matMenu">
                                            <button id="btn_mis_seguros" mat-menu-item (click)="onMisSeguros()">
                                                <span>Mis Seguros</span>
                                            </button>
                                            <button id="btn_cierra_session" mat-menu-item (click)="onCerrarSession()">
                                                <span>Cerrar Sessión</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </span>
                        </ng-container>
                        <ng-template #elseProfile>
                            <div class="column ocultar-btn mt-15">
                                <img class="logo"
                                [src]="styleCocheSeguro.srcLogo"
                                (click)="inicio()">
                                <mat-icon mat-dialog-close class="btn-close float-right">close</mat-icon>
                            </div>
                            <div class="table-sio w-100 text-center ocultar-btn">
                                <mat-divider></mat-divider>
                                <div class="row-sio">
                                    <a class="link line-h" id="btn_menu_cotizador" (click)="openSectionQuote()"> Cotizador </a>
                                </div>
                                <div class="row-sio">
                                    <a class="link line-h" id="btn_menu_beneficiarios" (click)="openSectionBenefits()"> Beneficios</a>
                                </div>
                                <div class="row-sio">
                                    <a class="link line-h" id="btn_menu_preg_frec" (click)="openWindow(5)"> Preguntas frecuentes </a>
                                </div>
                                <div class="row-sio">
                                    <a id="btn_menu_productos" class="line-h link" (click)="openSectionProduct()"> Nuestros productos </a>
                                </div>
                                <div class="row-sio">
                                    <a id="btn_menu_nosotros" class="link line-h" (click)="openWindow(4)">Sobre nosotros</a>
                                </div>
                                <div class="row-sio">
                                    <a id="btn_menu_contacto" class="link line-h" (click)="openModalMarcame()"> Contacto </a>
                                </div>
                                <div class="row-sio">
                                    <a id="btn_menu_login" class="link line-h" (click)="onLogin()">Login</a>
                                </div>
                            </div>


                            <div *ngIf="!isUpSivale" >
                                <a id="btn_login" class="link aboton" (click)="onLogin()">
                                    <div class="table-sio float-right">                                
                                        <div  class="cell-sio text-middle text-center pl-10x">Login</div>
                                    </div>

                                </a>
                            </div>


                        </ng-template>

                    </div>
                </div>
            </div>
            <div class="cell-sio text-middle w-ssm-50x text-center w-lg-235x">
                    <div class="cell-sio ocultar-btn">
                        <div mat-flat-button id="btn_contactanos" class="row ocultar-btn btn-call" (click)="openModalMarcame()">
                            <mat-icon style="font-size: 14px; padding-top: 5px;">phone</mat-icon>
                            <span style="font-weight: 600;">Contáctanos</span>
                        </div>
                    </div>
                    <div class="cell-sio">
                        <span class="menu-md-options">
                            <button mat-icon-button (click)="isMenuActive = !isMenuActive">
                                <mat-icon>menu</mat-icon>
                            </button>
                            <div class="menu-option" [class.active]="isMenuActive" (click)="isMenuActive = !isMenuActive">
                                <nav class="menu-option-nav border-nav-left">
                                    <ng-container *ngIf="isProfile; else elseProfile">
                                        <div class="profile-cont text-center my-10x">
                                            <img class="profile-img" [src]="profile.photo">
                                            <h4 class="profile-t">{{profile.nombre}}</h4>
                                            <p class="profile-s">{{profile.correo}}</p>
                                        </div>
                                    </ng-container>
                                    <ng-template #elseProfile>
                                        <a class="link" id="btn_mis_seguros" (click)="onLogin()">
                                            <div class="table-sio">
                                                <div class="cell-sio text-middle text-center">
                                                    <mat-icon class="text-middle">account_circle</mat-icon>
                                                </div>
                                                <div class="cell-sio text-middle text-center pl-10x">Mis Seguros</div>
                                            </div>
                                        </a>
                                    </ng-template>
                                    <mat-action-list>
                                        <ng-container *ngIf="isProfile">
                                            <button id="btn_mis_seguros" mat-list-item (click)="onMisSeguros()">
                                                <mat-icon mat-list-icon>pageview</mat-icon>
                                                <h4 mat-line>Mis Seguros</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                            <button id="btn_quienes_somos" mat-list-item (click)="OpcionMenu(4)">
                                                <mat-icon mat-list-icon>supervisor_account</mat-icon>
                                                <h4 mat-line>Quiénes Somos</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                        <ng-container *ngIf="isProfile">
                                            <button id="btn_cerrar_sesion" mat-list-item (click)="onCerrarSession()">
                                                <mat-icon mat-list-icon>exit_to_app</mat-icon>
                                                <h4 mat-line>Cerrar Sessión</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                        <ng-container *ngIf="!isProfile">
                                            <button id="btn_login" mat-list-item (click)="openWindow(7)">
                                                <h4 mat-line>Seguros</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                        <ng-container *ngIf="!isProfile">
                                            <button id="btn_login" mat-list-item (click)="openWindow(4)">
                                                <h4 mat-line>¿Quienes somos?</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                        <ng-container *ngIf="!isProfile">
                                            <button id="btn_login" mat-list-item (click)="openWindow(3)">
                                                <h4 mat-line>Blog</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                        <ng-container *ngIf="!isProfile">
                                            <button id="btn_login" mat-list-item (click)="openWindow(2)">
                                                <h4 mat-line>Promociones</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                        <ng-container *ngIf="!isProfile">
                                            <button id="btn_login" mat-list-item (click)="onLogin()">
                                                <mat-icon mat-list-icon>exit_to_app</mat-icon>
                                                <h4 mat-line>Login</h4>
                                            </button>
                                            <mat-divider></mat-divider>
                                        </ng-container>
                                    </mat-action-list>
                                </nav>
                            </div>
                        </span>
                    </div>

            <div class="cell-sio text-middle">
                <button class="button-sharet-link" *ngIf="validaDominio()"  (click)="onCopyToClipboard()">Compartir link</button>
            </div>
            </div>

        </ng-container>
    </div>
</div>

